import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { situations } from "../data/content";
export function Situations() {
  return <section className="bg-canvas px-4 py-16 sm:px-6 sm:py-20" data-id="element-254" data-mp="ry2pixt6gihx">
      <div className="mx-auto max-w-3xl" data-id="element-255" data-mp="rwjatbn66fi9">
        <SectionHeading kicker="Do any of these sound familiar?" title="If you recognize yourself here, I created this system for you." data-id="element-256" data-mp="vzxp9xvgmntl" />

        <ol className="mt-10 space-y-4" data-id="element-257" data-mp="10wofvf4w51t9">
          {situations.map((s, i) => <li key={s.title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-sm sm:p-6" data-id="element-258" data-mp="15vrb67v2jto1" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand font-display text-lg font-extrabold text-white" data-id="element-259" data-mp="1ap3xgbc9zodm">
                {i + 1}
              </span>
              <div data-id="element-260" data-mp="1jqto3eyc2jac">
                <h3 className="font-display text-[19px] font-bold leading-snug text-ink sm:text-xl" data-id="element-261" data-mp="1jn5s895f1ksg">{s.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-ink-soft" data-id="element-262" data-mp="3lhxwurfqspk9">{s.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 rounded-3xl bg-night px-6 py-10 text-white sm:px-10" data-id="element-263" data-mp="3hfjdm685vnsg">
          <p className="text-[17px] text-white/80" data-id="element-264" data-mp="3ciav24j3phqo">And here's what I've learned.</p>
          <p className="mt-4 font-display text-2xl font-extrabold leading-snug sm:text-3xl" data-id="element-265" data-mp="37iybbsnj0qsb">
            The problem isn't always a lack of technical knowledge.
          </p>
          <p className="mt-4 text-[17px] leading-relaxed text-white/85" data-id="element-266" data-mp="41g1xgs3vbps">
            Sometimes, the problem is that you have{" "}
            <strong className="text-gold" data-id="element-267" data-mp="3vfc729b2oi44">no consistent system</strong> for organizing the knowledge, evidence, and
            decisions required to investigate a fault.
          </p>
          <p className="mt-4 text-[17px] leading-relaxed text-white/85" data-id="element-268" data-mp="rriudxzxmjox">
            You shouldn't have to remember every detail of every previous case to work in a structured way. You need
            a process that helps you decide what information matters, what you've established, and what to
            investigate next.
          </p>
          <p className="mt-4 text-[17px] font-semibold text-white" data-id="element-269" data-mp="2l982umpuye9j">
            That's the purpose of the CAN Bus Diagnostic Blueprint.
          </p>
        </div>

        <div className="mt-10" data-id="element-270" data-mp="2cgwer7i7v2wq">
          <CtaButton label="Get the complete Blueprint" arrow data-id="element-271" data-mp="2cfuz0pq99s8o" />
        </div>
      </div>
    </section>;
}